import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import Box from '@mui/system/Box';
import {
    FormLabel, FormControl, AccordionSummary, Accordion, AccordionDetails, Typography,
    Select, MenuItem, TextField, Button, OutlinedInput
} from '@mui/material';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDate, getVFASOList, actionGetSupervisorActionLogList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

const SupervisorActionLogList = (props) => {
    const [vfaspList, setVfaspList] = useState([]);
    const [searchVfaspID, setSearchVfaspID] = useState(' ');
    const [language, setLanguage] = useState("");
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [supervisorActionLogList, setSupervisorActionLogList] = useState(null);

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchVFASPID: searchVfaspID.trim(),
            SearchField: searchField,
            SearchKeyword: searchKeyword,
            SearchDateFrom: dateFrom ? formatDate(dateFrom) : '',
            SearchDateTo: dateTo ? formatDate(dateTo) : '',
        };
        props.actionGetSupervisorActionLogList(requestBody);
        setSupervisorActionLogList([]);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            case "search-vfasp":
                setSearchVfaspID(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const handleDateFromChange = (e) => {
        resetTimout();
        setDateFrom(e);
    };

    const handleDateToChange = (e) => {
        resetTimout();
        setDateTo(e);
    };

    useEffect(() => {
        if (props?.supervisorActionLogList?.length > 0) {
            setSupervisorActionLogList(props.supervisorActionLogList);
        }
    }, [props.supervisorActionLogList]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: ''
        };
        props.actionGetSupervisorActionLogList(requestBody);
        setVfaspList(getVFASOList());
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-SupervisorActionLogList')}</h2>

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <FormLabel component="legend" required={false}>{translate('Search-CASP')}</FormLabel>
                            <Select style={{ minWidth: 80 }} name="search-vfasp" labelId="vfasp-label" value={searchVfaspID} onChange={handleChange} className="input-item-label" input={<OutlinedInput label={translate('Search-CASP')} />}>
                                <MenuItem value={' '}><em>{translate('Search-All')}</em></MenuItem>
                                {vfaspList?.map((vfasp, index) => {
                                    return <MenuItem key={vfasp.ClientID} value={vfasp.ClientID}>{vfasp.ClientName}</MenuItem>
                                })
                                }
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={1}>{translate('AdminID')}</MenuItem>
                                <MenuItem value={2}>{translate('UserID')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <br />
                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <DesktopDatePicker
                                id="id_DateFrom"
                                name="id_DateFrom"
                                label={translate('Search-DateFrom')}
                                inputFormat="yyyy/MM/dd"
                                value={dateFrom}
                                onChange={handleDateFromChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <DesktopDatePicker
                                id="id_DateTo"
                                name="id_DateTo"
                                label={translate('Search-DateTo')}
                                inputFormat="yyyy/MM/dd"
                                value={dateTo}
                                onChange={handleDateToChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            <table className="adminTable" style={{ width: 1010 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '7%' }}>{translate('VFASPID')}</th>
                        <th className="adminTH" style={{ width: '14%' }}>{translate('AdminID')}</th>
                        <th className="adminTH" style={{ width: '12%' }}>{translate('AdminName')}</th>
                        <th className="adminTH" style={{ width: '13%' }}>{translate('ActionDate')}</th>
                        <th className="adminTH" style={{ width: '12%' }}>{translate('UserID')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('FormName')}</th>
                        <th className="adminTH" style={{ width: '10%' }}>{translate('FieldName')}</th>
                        <th className="adminTH" style={{ width: '11%' }}>{translate('OldValue')}</th>
                        <th className="adminTH" style={{ width: '11%' }}>{translate('NewValue')}</th>
                    </tr>
                    {supervisorActionLogList?.map((admin, index) => {
                        return <tr className="adminTR" key={admin.AUTORECID}>
                            <td className="adminTD" width='7%' align='center'>{admin.VFASPID}</td>
                            <td className="adminTD" width='14%' align='center'>{admin.AdminID}</td>
                            <td className="adminTD" width='12%' align='left'>{admin.AdminName}</td>
                            <td className="adminTD" width='13%' align='left'>{admin.ActionDate}</td>
                            <td className="adminTD" width='12%' align='center'>{admin.UserID}</td>
                            <td className="adminTD" width='10%' align='center'>{admin.FormName}</td>
                            <td className="adminTD" width='10%' align='center'>{admin.FieldName}</td>
                            <td className="adminTD" width='11%' align='center'>{admin.OldValue}</td>
                            <td className="adminTD" width='11%' align='center'>{admin.NewValue}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

        </div>

    );
};

const mapStateToProps = state => {
    return {
        supervisorActionLogList: state.remote.supervisorActionLogList
    };
};

export default connect(mapStateToProps, {
    actionGetSupervisorActionLogList
})(SupervisorActionLogList);
